import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import { PHONE_NUMBER, EMAIL_ADDRESS } from '../App.js';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Toggle function for the hamburger menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close the menu when an option is selected
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Handle clicks outside the menu to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    // Add event listener for detecting clicks outside
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  return (
    <header className="header">
      <Link to="/" className="logo">PaperForLess</Link>

      {/* Hamburger Menu */}
      <div className="hamburger" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      {/* Navigation menu with dynamic class to show/hide */}
      <div ref={menuRef} className={`navBox ${menuOpen ? 'show' : ''}`}>
        <ul>
          <Link to="/" onClick={closeMenu}>
            <li>Home</li>
          </Link>
          <li onClick={closeMenu}>
            <i className="fas fa-phone-alt"></i>{PHONE_NUMBER}
          </li>
          <li onClick={closeMenu}>
            <i className="fas fa-envelope"></i> {EMAIL_ADDRESS}
          </li>
          <Link to="/quote" onClick={closeMenu}>
            <li>Request a Quote</li>
          </Link>
        </ul>
      </div>
    </header>
  );
};

export default Header;
